import { cloneDeep } from "lodash";
import { make } from "vuex-pathify";
import Client from "./model";
import store from "../..";
import { parseISO } from "date-fns";

const defaultClient = {
    currency: null,
    data_started_at: null,
    logo: null,
    name: null,
}

const state = {
    loading: false,
    creating: false,
    updating: false,
    destroying: false,
    client: cloneDeep(defaultClient),
    clients: [],
    sortBy: '-created_at',
    filters: {},
    pagination: {
        current_page: 1,
        from: null,
        last_page: null,
        path: null,
        per_page: null,
        to: null,
        total: null
    },
};

const mutations = make.mutations(state);

const actions = {
    async load({ commit }, id) {
        let client = {};

        try {
            commit("loading", Client.$find(id));
            client = await store.get("clients/loading");

            commit("loading", false);
        } catch (error) {
        //
        }

        client.created_at = parseISO(client.created_at)
        client.data_started_at = parseISO(client.data_started_at)
        client.updated_at = parseISO(client.updated_at)

        commit("client", client);
    },

    async loadClients({ commit }, filter = true) {
        let clients = null;

        try {
            let filters = store.get("clients/filters")
            let query = Client
                .orderBy(store.get("clients/sortBy"))

            if (filter) {
                for (const key in filters) {
                    if (filters.hasOwnProperty(key)) {
                        query.where(key, filters[key])

                        if (key === 'search' && filters[key].length !== 0) {
                            store.set("clients/pagination@current_page", 1)
                        }
                    }
                }

                // query.page(store.get("clients/pagination@current_page"))
                query.get()
            }

            commit("loading", query.get())
            clients = await store.get("clients/loading");

            commit("loading", false);
        } catch (error) {
        //
        }

        commit("clients", clients.data);
        commit("pagination", clients.meta);
    },

    resetClient({ commit }) {
        commit('client', cloneDeep(defaultClient))
    },

    async create({commit, dispatch}, payload) {
        let client = new Client(payload)
        let response = null

        try {
            commit("loading", client.save());
            response = await store.get("clients/loading");
            commit("loading", false);

            dispatch("loadClients");
        } catch (error) {
            throw error
        }

        return response.data
    },

    async update({commit, dispatch}, payload) {
        let client = new Client(payload)
        let response = null

        try {
            commit("loading", client.save());
            response = await store.get("clients/loading");
            commit("loading", false);

            dispatch("loadClients");
        } catch (error) {
            throw error
        }

        store.set('auth/client', response.data)
    },

    async updateLogo({commit, dispatch}, {resource, formData}) {
        let client = new Client(resource)

        try {
            commit("loading", client.updateLogo(formData))
            client = await store.get("clients/loading")
            commit("loading", false)
        } catch (error) {
            throw error
        }

        store.set('auth/client', client)

        return client.logo
    },

    async updateOrder({commit, dispatch}, {client, sorted}) {
        client = new Client(client)

        try {
            await client.updateOrder(sorted)
        } catch (error) {
            throw error
        }
    },

    async destroy({commit, dispatch}, payload) {
        try {
            commit("loading", payload.delete());
            await store.get("clients/loading");
            commit("loading", false);
        } catch (error) {
            throw error
        }
    },

    async searchedClients({commit, dispatch}, payload) {
        let clients = new Client({id: payload})

        try {
            commit("loading", clients.searchedClients())
            client = await store.get("clients/loading")
            commit("loading", false);
        } catch (error) {
        //
        }

        return client
    }
};

const getters = {
    //
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
